var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ProductTitle from './product_title';
import ShortSpec from './short_spec';
import Buttons from './buttons';
var ProducHead = function () {
    var item = useSelector(function (state) { return state.product.item; });
    if (!item)
        return null;
    return (React.createElement(Style, null,
        React.createElement(ProductTitle, { title: item.full_item_name }),
        "    ",
        React.createElement(Article, null,
            React.createElement(ShortSpec, { spec: item.item_br_info }),
            "      ",
            React.createElement(Buttons, { item: item }),
            "                     ")));
};
var Style = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 0 30px;\n    border-bottom: 1px solid #c5c5c5;\n"], ["\n    margin: 0 0 30px;\n    border-bottom: 1px solid #c5c5c5;\n"])));
var Article = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between\n"], ["\n    display: flex;\n    justify-content: space-between\n"])));
export default ProducHead;
var templateObject_1, templateObject_2;



//////////////////
// WEBPACK FOOTER
// ./src/detail/components/product_head/index.tsx
// module id = 178
// module chunks = 0